import axios from "axios";
import { message, Spin } from "ant-design-vue";
import store from "@/store";
import { getToken } from "@/utils/auth";
import errorCode from "@/utils/errorCode";
import { tansParams, blobValidate } from "@/utils/ruoyi";
import cache from "@/plugins/cache";
import { saveAs } from "file-saver";

let downloadLoadingInstance;
// 是否显示重新登录
export let isRelogin = { show: false };

axios.defaults.headers["Content-Type"] = "application/json;charset=utf-8";
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: "https://znhl.org.cn",
  // 超时
  timeout: 10000,
});

// request拦截器
service.interceptors.request.use(
  (config) => {
    // 是否需要设置 token
    const isToken = (config.headers || {}).isToken === false;
    // 是否需要防止数据重复提交
    const isRepeatSubmit = (config.headers || {}).repeatSubmit === false;
    if (getToken() && !isToken) {
      config.headers["Authorization"] = "Bearer " + getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    // get请求映射params参数
    if (config.method === "get" && config.params) {
      let url = config.url + "?" + tansParams(config.params);
      url = url.slice(0, -1);
      config.params = {};
      config.url = url;
    }
    if (
      !isRepeatSubmit &&
      (config.method === "post" || config.method === "put")
    ) {
      const requestObj = {
        url: config.url,
        data:
          typeof config.data === "object"
            ? JSON.stringify(config.data)
            : config.data,
        time: new Date().getTime(),
      };
      const requestSize = Object.keys(JSON.stringify(requestObj)).length; // 请求数据大小
      const limitSize = 5 * 1024 * 1024; // 限制存放数据5M
      if (requestSize >= limitSize) {
        console.warn(
          `[${config.url}]: ` +
            "请求数据大小超出允许的5M限制，无法进行防重复提交验证。"
        );
        return config;
      }
      // const sessionObj = cache.session.getJSON("sessionObj");
      // if (
      //   sessionObj === undefined ||
      //   sessionObj === null ||
      //   sessionObj === ""
      // ) {
      //   cache.session.setJSON("sessionObj", requestObj);
      // } else {
      //   const s_url = sessionObj.url; // 请求地址
      //   const s_data = sessionObj.data; // 请求数据
      //   const s_time = sessionObj.time; // 请求时间
      //   const interval = 1000; // 间隔时间(ms)，小于此时间视为重复提交
      //   if (
      //     s_data === requestObj.data &&
      //     requestObj.time - s_time < interval &&
      //     s_url === requestObj.url
      //   ) {
      //     const message = "数据正在处理，请勿重复提交";
      //     console.warn(`[${s_url}]: ` + message);
      //     return Promise.reject(new Error(message));
      //   } else {
      //     cache.session.setJSON("sessionObj", requestObj);
      //   }
      // }
    }
    return config;
  },
  (error) => {
    console.log(error);
    Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (res) => {
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    // 获取错误信息
    const msg = errorCode[code] || res.data.msg || errorCode["default"];
    // 二进制数据则直接返回
    if (
      res.request.responseType === "blob" ||
      res.request.responseType === "arraybuffer"
    ) {
      return res.data;
    }
    if (code === 401) {
      if (!isRelogin.show) {
        isRelogin.show = true;
        message.error("登录状态已过期，您可以继续留在该页面，或者重新登录");
        isRelogin.show = false;
        store.dispatch("LogOut");
      }
      return Promise.reject("无效的会话，或者会话已过期，请重新登录。");
    } else if (code === 500) {
      message.error(msg);
      return Promise.reject(new Error(msg));
    } else if (code === 601) {
      message.warning(msg);
      return Promise.reject("error");
    } else if (code !== 200) {
      message.error(msg);
      return Promise.reject("error");
    } else {
      return res.data;
    }
  },
  (error) => {
    console.log("err" + error);
    let { message: msg } = error;
    if (msg == "Network Error") {
      msg = "后端接口连接异常";
    } else if (msg.includes("timeout")) {
      msg = "系统接口请求超时";
    } else if (msg.includes("Request failed with status code")) {
      msg = "系统接口" + msg.substr(msg.length - 3) + "异常";
    }
    message.error(msg);
    return Promise.reject(error);
  }
);

function handleDownloadError(data) {
  const resText = new TextDecoder().decode(data); // 将 ArrayBuffer 转为文本
  try {
    const rspObj = JSON.parse(resText); // 解析为 JSON
    const errMsg = rspObj.message || "下载文件失败！";
    message.error(errMsg); // 提示错误信息
  } catch (e) {
    message.error("返回的文件内容无法解析为 JSON。");
  }
}

function getFileNameFromHeaders(headers) {
  const disposition = headers["content-disposition"];
  if (disposition && disposition.includes("filename=")) {
    const filename = disposition.split("filename=")[1].replace(/['"]/g, ""); // 去除引号
    return decodeURIComponent(filename); // 进行 URI 解码
  }
  return null;
}

// 通用下载方法
export function download(url, filename = "file", config = {}, fileType = "") {
  downloadLoadingInstance = message.loading("正在下载文件，请稍候", 0);
  return axios
    .get(url, {
      url: url,
      method: "get",
      responseType: "arraybuffer", // 使用 arraybuffer 来接收数据
      ...config,
    })
    .then((response) => {
      console.log(response, response);
      const contentType = response.headers["content-type"] || fileType;
      const blob = new Blob([response.data], { type: contentType });

      if (blob.size > 0) {
        saveAs(blob, filename); // 使用 file-saver 保存文件
      } else {
        handleDownloadError(response.data); // 处理错误情况
      }
      downloadLoadingInstance();
    })
    .catch((r) => {
      console.error(r);
      message.error("下载文件出现错误，请联系管理员！");
      downloadLoadingInstance();
    });
}

export default service;
